export const membersFFAppDefId = '14ebe801-d78a-daa9-c9e5-0286a891e46f';
export const aboutAppDefinitionId = '14dbef06-cc42-5583-32a7-3abd44da4908';
export const myAccountAppDefinitionId = '14cffd81-5215-0a7f-22f8-074b0e2401fb';
